import React from "react";
import PropTypes from "prop-types";
import { Table } from "../../../../components/ui/Table";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "../../../../components/ui/Tooltip";
import { useDeleteTemplatesMessage } from "../hooks/useFetchTemplatesMessage";
import { dateFormat } from "../../../../utils/dateHelpers";
import { classNames } from "../../../../utils/helpers";
const TableMessageTemplates = (props) => {
  const { data, isLoading = false } = props;
  const navigate = useNavigate();
  const { mutate: deleteTemplate } = useDeleteTemplatesMessage();
  const COLS = [
    {
      Header: "Nombre",
      accessor: "name",
    },
    {
      Header: "Mensaje",
      accessor: "rcs_message",
    },
    {
      Header: "Tipo",
      accessor: "step",
      Cell: (rowValue) => {
        let value = rowValue.row.original?.step;

        const types = {
          1: {
            label: "Single",
            className: "bg-blue-100 text-blue-700",
          },
          2: {
            label: "Rich Card",
            className: "bg-violet-100 text-violet-700",
          },
          3: {
            label: "Carousel",
            className: "bg-amber-100 text-amber-700",
          },
        };

        const item = types[value];

        return (
          <span
            className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold ${item.className}`}
          >
            {item.label}
          </span>
        );
      },
    },
    {
      Header: "Categoría",
      accessor: "category",
      Cell: (rowValue) => {
        let value = rowValue.row.original?.category;

        const categories = {
          PROMOTIONAL: "Promocionales",
          "MULTI-USE": "Multiuso",
          OTP: "OTP",
          TRANSACTIONAL: "Transaccional",
        };
        return (
          <span className="inline-flex items-center rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold capitalize text-slate-700">
            {categories[value] || value}
          </span>
        );
      },
    },
    {
      Header: "Estatus",
      accessor: "status",
      Cell: (rowValue) => {
        let value = rowValue.row.original?.status;

        return (
          <span
            className={classNames(
              "inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold",
              {
                "bg-emerald-100 text-emerald-700": value,
                "bg-red-100 text-red-700": !value,
              },
            )}
          >
            <span
              className={classNames("h-2 w-2 rounded-full", {
                "bg-emerald-500": value,
                "bg-red-500": !value,
              })}
            />
            {value ? "Activo" : "Inactivo"}
          </span>
        );
      },
    },
    {
      Header: "Creado",
      accessor: "created_at",
      Cell: (rowValue) => {
        let value = rowValue.row.original?.created_at;

        return (
          <span className="text-[12px]">
            {" "}
            {dateFormat(value, "DD/MMM/YYYY HH:mm")}
          </span>
        );
      },
    },
    {
      Header: "Acciones",
      accessor: "actions",
      Cell: (rowValue) => {
        let uuid = rowValue.row.original?.uuid_messages_templates;

        return (
          <div className="flex justify-center gap-2">
            <Tooltip message="Detalles" placement="top">
              <button
                className="bg-gray-100 hover:bg-gray-200 hover:text-gray-400 text-gray-700 border-none rounded-lg flex items-center gap-2 px-2 py-1"
                onClick={() => navigate(`/rcs/MessageTemplates/${uuid}`)}
              >
                <span className="material-symbols-outlined">
                  arrow_right_alt
                </span>
              </button>
            </Tooltip>
            <Tooltip message="Eliminar" placement="top">
              <button
                className="bg-gray-100 hover:bg-gray-200 hover:text-gray-400 text-gray-700 border-none rounded-lg flex items-center gap-2 px-2 py-1"
                onClick={async () => {
                  await deleteTemplate(uuid);
                }}
              >
                <span className="material-symbols-outlined">delete</span>
              </button>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  return (
    <Table
      data={data}
      columns={COLS}
      loading={isLoading}
      config={{
        search: true,
        pagination: true,
        pageSize: 10,
        footer: true,
      }}
    />
  );
};

TableMessageTemplates.propTypes = {
  data: PropTypes.array,
  isLoading: PropTypes.bool,
};

export default TableMessageTemplates;
